export enum ProductSearchType {
  GenericRackSelector,
  RooftopTentsRackSelector,
  SelectList,
  VariationSelector,
  LoadingFromCookie,
}

export default ProductSearchType;
